// extracted by mini-css-extract-plugin
export var deleteIcon = "_sh-5";
export var deleteOption = "_sh-3";
export var divider = "_sh-2";
export var downloadIcon = "_sh-4";
export var drawer = "_sh-0";
export var drawerFooter = "_sh-6";
export var drawerOpen = "_sh-1";
export var highlighted = "_sh-7";
export var lighterHighlight = "_sh-8";